
const initState = () => ({
  customerFinancialSettings: {},
  customerId: null,
})
export const state = initState
export const mutations = {
  setCustomerFinancialSettings(state, {customerFinancialSettings}) {
    state.customerFinancialSettings = customerFinancialSettings
  },
  setCustomerId(state, {customerId}){
    state.customerId = customerId;
  }
}
export const getters = {
  getCustomerFinancialSettings(state) {
    return state.customerFinancialSettings
  },
  getCustomerId(state){
    return state.customerId;
  }
}
export const actions = {
  async getCustomerFinancialSetting({commit}) {
    const customerFinancialSettingResponse = await this.$axios.$get('/customerfinancialsetting')
    if(customerFinancialSettingResponse){
      if(customerFinancialSettingResponse.hasErrors){
        customerFinancialSettingResponse.errorMessages.map((error, index) =>{
          this.$toast.error(error.value)
        })
      }else{
        commit('setCustomerFinancialSettings', {customerFinancialSettings: customerFinancialSettingResponse.value})
      }
    }
  },
  async getHasCustomerDiscountOrMarkupByItemType({commit}, {itemTypeId}){
    const response = await this.$axios.$get(`/customers/has-customer-discount-or-markup-by-item-type/${itemTypeId}`)
    if(response.hasErrors === false){
      if(response.value){
        return response.value.hasDiscountOrMarkup
      } else {
        return false
      }
    } else {
      if(response.errorMessages){
        response.errorMessages.map((error, index) =>{
          this.$toast.error(error.value)
        })
      }
      return false
    }
  },
  async getCustomerBasedOnAccountNo({commit}, {accountNo}){
    try {
      const response = await this.$axios.$get(`/customers/get-id-by-account-number/${accountNo}`)

      if(response.apiMessages.hasErrors === false){
        commit('setCustomerId', {customerId: response.value})
      } else {
        this.$toast.error("Error while getting customer!")
      }
    }
    catch (e) {
      if (e.response){
        console.error(e.response)
        this.$toast.error(e.response.data.Message)
      }else {
        this.$toast.error(e)
      }
    }
  }
}
